import { t } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';
import { DropTarget } from 'react-dnd';

import { addToLabel } from '@api/v4/bulk_actions/assets';

const LabelContent = ({
  childrenPanelId,
  connectDropTarget,
  hasChildren,
  indentationLevel,
  isExpanded,
  isHovered,
  labelId,
  name,
  onLabelSelect,
  toggleExpand,
}) => {
  // Branches use a real heading for outline/AT; leaves use a div so the tree is not all h3s.
  const NameShell = hasChildren ? 'h3' : 'div';
  const depthPaddingPx = 12 + indentationLevel * 20;

  return connectDropTarget(
    <div
      className={`label-name-container label-tree-item ${isHovered ? 'hover' : ''}`}
      style={{ paddingLeft: `${depthPaddingPx}px` }}
    >
      <div className="label-tree-row">
        <div className="label-chevron-cell">
          {hasChildren ? (
            <button
              aria-controls={childrenPanelId}
              aria-expanded={isExpanded}
              aria-label={isExpanded ? t`Collapse ${name}` : t`Expand ${name}`}
              className="expand-button"
              onClick={() => toggleExpand(labelId)}
              type="button"
            >
              <span aria-hidden className="bff-caret-down icon" />
            </button>
          ) : null}
        </div>
        <NameShell className="name-copy" title={name}>
          <button
            className="select-button"
            onClick={() => {
              toggleExpand(labelId, true, true);
              onLabelSelect(labelId);
            }}
            type="button"
          >
            <span aria-hidden className="bff-label icon" />
            <span className="label-name-text">{name}</span>
          </button>
        </NameShell>
      </div>
    </div>
  );
};

LabelContent.propTypes = {
  childrenPanelId: PropTypes.string,
  connectDropTarget: PropTypes.func.isRequired,
  hasChildren: PropTypes.bool,
  indentationLevel: PropTypes.number,
  isExpanded: PropTypes.bool,
  isHovered: PropTypes.bool,
  labelId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onLabelSelect: PropTypes.func.isRequired,
  toggleExpand: PropTypes.func.isRequired,
};

LabelContent.defaultProps = {
  childrenPanelId: undefined,
  hasChildren: false,
  indentationLevel: 0,
  isExpanded: false,
  isHovered: false,
};

const assetTarget = {
  drop({ labelId }, monitor) {
    const { id, selectedAssetKeys } = monitor.getItem();
    addToLabel(Array.from(new Set([...selectedAssetKeys, id])), labelId);
  }
};

const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isHovered: monitor.isOver(),
});

export default DropTarget('asset-label', assetTarget, dropCollect)(LabelContent);
